import React from 'react';
import { Box, Button, Modal, Spinner, Text } from '@nimbus-ds/components';
import { useTranslationWithPrefix } from 'commons/utils';

interface LeaveD0ModalProps {
  open: boolean;
  confirmDisabled: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
}

function LeaveD0Modal({
  open,
  confirmDisabled,
  onConfirm,
  onDismiss,
}: LeaveD0ModalProps): JSX.Element {
  const { t } = useTranslationWithPrefix('settlementPeriod.leaveD0Modal');

  return (
    <Modal data-testid="leave-d0-modal" open={open} onDismiss={onDismiss}>
      <Modal.Header title={t('title')} />
      <Modal.Body padding="none">
        <Box display="flex" flexDirection="column" gap="2">
          <Text textAlign="left">{t('description')}</Text>
          <Text textAlign="left">{t('question')}</Text>
        </Box>
      </Modal.Body>
      <Modal.Footer>
        <Button appearance="neutral" onClick={onDismiss}>
          {t('cancel')}
        </Button>
        <Button
          appearance="primary"
          disabled={confirmDisabled}
          onClick={onConfirm}
        >
          {confirmDisabled && <Spinner color="currentColor" size="small" />}
          {t('confirm')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default LeaveD0Modal;
